import axios from 'axios'
import Vue from 'vue'
const _instance = new Vue()

axios.defaults.timeout = 400000
axios.defaults.baseURL = '/api/'
axios.interceptors.request.use(
  config => {
    return config
  },
  err => Promise.reject(err)
)

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const code = error.response.status
      switch (code) {
        case 500:
          break
        case 401:
          break
      }
    }
    _instance.$toast(error.message || error)
    return Promise.resolve(Object.create(null)) // 以免数据解构错误
  }
)

// TODO 自定义接口
//获取openid接口
export const openId = (options) => {
    return axios.get('uba/wx/openid', {
        params: options
    })
}

// 获取userInfo
export const userInfo = (options) => {
    return axios.get('uba/wx/info', {
        params: options
    })
}

//获取分享参数
export const wxShare = (options) => {
    return axios.get('uba/wx/wxShare', {
        params: options
    })
}

//登录
export const login = (options) => {
    return axios.get('soli/login', {
        params: options
    })
}

//登录
export const loginByOpenId= (options) => {
    return axios.get('soli/loginByOpenId', {
        params: options
    })
}

//知情同意
export const agree = (options) => {
    return axios.get('soli/agree', {
        params: options
    })
}

//获取首页数据
export const index = (options) => {
    return axios.get('soli/index', {
        params: options
    })
}

//提交/编辑病例
export const addCase = (options) => {
    return axios.post('soli/addCase', options, null)
}

//获取病例
export const getCase = (options) => {
    return axios.get('soli/getCase', {
        params: options
    })
}


//获取ossSecret
export const getOssSecret = (options) => {
    return axios.get('hyper/doc/ossSecret', {
        params: options
    })
}

//wxsw登录
//登录
export const wLogin = (options) => {
    return axios.get('wxsw/login', {
        params: options
    })
}

//wxsw案例提交
export const wxAddCase = (options) => {
    return axios.post('wxsw/addCase', options, null)
}

//wxsw案例获取
export const wxGetCase = (options) => {
    return axios.get('wxsw/getCase', {
        params: options
    })
}

//wxsw案例获取
export const wxGetCaseById = (options) => {
    return axios.get('wxsw/getCaseById', {
        params: options
    })
}

//打分
export const wxScoreCase = (options) => {
    return axios.post('wxsw/caseScore', options, null)
}

//获取
export const getCaseScore = (options) => {
    return axios.get('wxsw/getCaseScore', {
        params: options
    })
}

//获取评委病例
export const getJudgeCase = (options) => {
    return axios.get('wxsw/getJudgeCase', {
        params: options
    })
}

// 知情同意
export const wxAgree = (options) => {
    return axios.get('wxsw/agree', {
        params: options
    })
}
// 阿斯利康调研
export const aslkDoSurvey = (options) => {
    return axios.post('uba/aslk/doSurvey', options, null)
}
// 雅培答题
export const answerPlayerLogin = (options) => {
    return axios.get('answer/login', {
        params: options
    })
}
// 竞答题目状态
export const answerPlayerQuestionStation = (options) => {
    return axios.get('answer/myQuestionStation', {
        params: options
    })
}
// 获取题目
export const getAnswer = (options) => {
    return axios.get('answer/getAnswer', {
        params: options
    })
}
// 我的题目
export const myQuestion = (options) => {
    return axios.get('answer/myQuestion', {
        params: options
    })
}
// 题目提交
export const  answerSubmit= (options) => {
    return axios.post('answer/answerSubmit', options, null)
}
// 抢题目
export const  compQuestion= (options) => {
    return axios.get('answer/compQuestion', {
        params: options
    })
}
// 有用的抢答题
export const  valuableQuestion= (options) => {
    return axios.get('answer/valuableQuestion', {
        params: options
    })
}
// 获取所有的选手
export const  getPlayer= (options) => {
    return axios.get('answer/getPlayer', {
        params: options
    })
}
// 主持人开题
export const  hostStart= (options) => {
    return axios.get('answer/hostStart', {
        params: options
    })
}
// 获取选手竞答答案
export const  getPlayerCompAnswer= (options) => {
    return axios.get('answer/getPlayerCompAnswer', {
        params: options
    })
}
// 获取选手必答答案的状态
export const  getPlayerRegAnswerStation= (options) => {
    return axios.get('answer/getPlayerRegAnswerStation', {
        params: options
    })
}
// 获取选手必答答案的状态
export const  getPlayerAnswer= (options) => {
    return axios.get('answer/getPlayerAnswer', {
        params: options
    })
}
// 投屏接口
export const  toScreen= (options) => {
    return axios.get('answer/toScreen', {
        params: options
    })
}
// 获取单个选手
export const  getOnePlayer= (options) => {
    return axios.get('answer/getOnePlayer', {
        params: options
    })
}

/**
 * 旗开得胜
 */
// 获取所有选手
export const  getVotePlayers= (options) => {
    return axios.get('vote/getPlayers', {
        params: options
    })
}
// 开始
export const  voteStart= (options) => {
    return axios.get('vote/start', {
        params: options
    })
}
// 投屏
export const  votetoScreen= (options) => {
    return axios.get('vote/toScreen', {
        params: options
    })
}
// 获取选手
export const  getVotePlayer= (options) => {
    return axios.get('vote/getPlayer', {
        params: options
    })
}
// 开始投票
export const  voteScore= (options) => {
    return axios.get('vote/score', {
        params: options
    })
}
// 获取评分
export const  getScore= (options) => {
    return axios.get('vote/playerScore', {
        params: options
    })
}
// 获取浏览器评分
export const  getBrowserScore= (options) => {
    return axios.get('vote/getScore', {
        params: options
    })
}
// 旗开得胜 获取抢答题
export const  qCompQuestion= (options) => {
    return axios.get('answer/qCompQuestion', {
        params: options
    })
}
// 旗开得胜 判断题目是否可抢
export const  compEnable= (options) => {
    return axios.get('answer/compEnable', {
        params: options
    })
}
// 京答题提交
export const  compSubmit= (options) => {
    return axios.get('answer/compSubmit', {
        params: options
    })
}
// 获取所有竞答题
export const  allCompQuestion= (options) => {
    return axios.get('answer/allCompQuestion', {
        params: options
    })
}
// 跳过本题
export const  toNext= (options) => {
    return axios.get('answer/toNext', {
        params: options
    })
}

/**
 * K速达项目接口
 */
// 获取地址
export const  ksdAddress= (options) => {
    return axios.get('/ksd/rep/address', {
        params: options
    })
}
// 医生基本信息提交
export const  ksdAddDocInfo= (options) => {
    return axios.post('ksd/rep/addDocInfo', options, {})
}
// 获取验证码
export const  ksdDocGetCode= (options) => {
    return axios.get('/ksd/doc/getCode', {
        params: options
    })
}
// 验证码登录
export const  ksdDocLoginByCode= (options) => {
    return axios.get('/ksd/doc/loginByCode', {
        params: options
    })
}
// 获取当前阶段
export const  ksdPhase= (options) => {
    return axios.get('/ksd/doc/phase', {
        params: options
    })
}
// 达标学者提交
export const  ksdDocLearner= (options) => {
    return axios.post('ksd/doc/addLearner', options, {})
}
// 获取达标之星阶段
export const  ksdDocGetStar= (options) => {
    return axios.get('/ksd/doc/getStar', {
        params: options
    })
}
// 观念调查
export const  ksdDocSurvey= (options) => {
    return axios.post('ksd/doc/survey', options, {})
}
// 病例提交
export const  ksdAddStarCase= (options) => {
    return axios.get('/ksd/doc/addStarCase', {
        params: options
    })
}
// 视频提交
export const  ksdAddStarVideo= (options) => {
    return axios.get('/ksd/doc/addStarVideo', {
        params: options
    })
}
//获取账户信息
export const  ksdDocGetAccount= (options) => {
    return axios.get('/ksd/doc/getAccount', {
        params: options
    })
}
// 提交账户信息
export const  ksdDocAccount= (options) => {
    return axios.post('ksd/doc/account', options, {})
}
//查询支付情况
export const  ksdDocPayStation= (options) => {
    return axios.get('/ksd/doc/payStation', {
        params: options
    })
}
//添加评委信息
export const  ksdAddJudgeInfo= (options) => {
    return axios.post('ksd/judge/addInfo', options, {})
}
//评委登录
export const  ksdJudgeLogin= (options) => {
    return axios.get('/ksd/judge/login', {
        params: options
    })
}
//获取评委病例
export const  ksdJudgeGetCase= (options) => {
    return axios.get('/ksd/judge/getCase', {
        params: options
    })
}
//获取评委名额
export const  ksdJudgeGetQuota= (options) => {
    return axios.get('/ksd/judge/quota', {
        params: options
    })
}
//评委打分
export const  ksdJudgeCaseScore= (options) => {
    return axios.post('ksd/judge/score', options, {})
}
//添加账户
export const  ksdAddJudgeAccount= (options) => {
    return axios.post('ksd/judge/addAccount', options, {})
}
//获取账户
export const  ksdGetJudgeAccount= (options) => {
    return axios.get('ksd/judge/getAccount', {
        params:options
    })
}
//阅读隐私政策
export const  ksdDocPrivacy= (options) => {
    return axios.get('ksd/doc/privacy', {
        params:options
    })
}
//pdf时间
export const readingTime= (options) => {
    return axios.get('ksd/doc/learnerTime', {
        params:options
    })
}
//根据openid 登录
export const ksdDocLoginByOpenid= (options) => {
    return axios.get('ksd/doc/loginByOpenid', {
        params:options
    })
}

//获取北京健康医生
export const bjjkDoc= (options) => {
    return axios.get('talk/getBjDoc', {
        params:options
    })
}
//北京健康医生投票
export const bjDocVote= (options) => {
    return axios.get('talk/bjVote', {
        params:options,
        headers:{
            "sc-ua-token":options.token,
            "sc-ua-ts":options.time,
        }
    })
}
//北京健康医生
export const bjAgreement= (options) => {
    return axios.get('talk/bjAgreement', {
        params:options
    })
}
//代表差查询
export const repSearch= (options) => {
    return axios.get('ksd/rep/repSearch', {
        params:options
    })
}
//评委查询
export const judgeSearch= (options) => {
    return axios.get('ksd/rep/judgeSearch', {
        params:options
    })
}
//umed-劳务协议获取基本信息
export const agreementInfo= (options) => {
    return axios.get('u_agreement/getAgreementInfo', {
        params:options
    })
}
//umed-劳务协议获取基本信息
export const agreementBaseInfo= (options) => {
    return axios.get('u_agreement/getAgreementBaseInfo', {
        params:options
    })
}
//umed-劳务协议修改身份证信息
export const editId= (options) => {
    return axios.get('u_agreement/editId', {
        params:options
    })
}
//umed-劳务协议修改基本信息
export const editInfo= (options) => {
    return axios.get('u_agreement/editInfo', {
        params:options
    })
}
//umed-劳务协议签名
export const sign= (options) => {
    return axios.post('u_agreement/sign', options, {})
}
//开速达-推出
export const exit= (options) => {
    return axios.get('/ksd/doc/exit', {
        params:options
    })
}
//开速达-补充数量
export const ksdDocExaNumber= (options) => {
    return axios.get('/ksd/doc/getExaNumber', {
        params:options
    })
}
//开速达-补充状态
export const ksdDocExaStation= (options) => {
    return axios.get('/ksd/doc/getExaStarStation', {
        params:options
    })
}
//辉致直播信息收集
export const tvInfo= (options) => {
    return axios.post('/uba/aslk/infoSubmit', options, {})
}
//CDQI-选手列表-观众
export const cdqiPlayerListByAudience= (options) => {
    return axios.get('/plus/cdqi/playerListByAudience', {
        params:options
    })
}
//CDQI-选手打分-观众
export const cdqiScoreByAudience= (options) => {
    return axios.get('/plus/cdqi/scoreByAudience', {
        params:options
    })
}
//CDQI-专家登录
export const cdqiExpertLogin= (options) => {
    return axios.get('/plus/cdqi/expertLogin', {
        params:options
    })
}
//CDQI-选手列表-专家
export const cdqiPlayerListByExpert= (options) => {
    return axios.get('/plus/cdqi/playerListByExpert', {
        params:options
    })
}
//CDQI-专家打分
export const cdqiExpertScore= (options) => {
    return axios.get('/plus/cdqi/scoreByExpert', {
        params:options
    })
}
//编辑选手状态
export const cdqiEditPlayerStatus= (options) => {
    return axios.get('/plus/cdqi/editPlayerStatus', {
        params:options
    })
}
//签名登录
export const umedSignLogin= (options) => {
    return axios.get('u_sign/login', {
        params:options
    })
}
//获取签名信息
export const umedSignGet= (options) => {
    return axios.get('u_sign/getInfo', {
        params:options
    })
}
//umed-签名
export const umedSign= (options) => {
    return axios.post('u_sign/sign', options, {})
}
//为爱发声
export const addSayInfo= (options) => {
    return axios.post('/umed/say/addInfo', options, {})
}
//为爱发声
export const getSayInfo= (options) => {
    return axios.get('/umed/say/getInfo', {
        params:options
    })
}
